<!--
* @Name：验收附件
* @Author: 王超
* @Date: 2025-10-28
-->
<template>
  <div>
    <hi-card v-for="(item, index) in detailsList" :key="item.id" :row-index="index + 1">
      <van-row>
        <span>验收条件：</span>
        <span>{{ item.receiveCondition }}</span>
      </van-row>
      <van-row>
        <span>附件是否必传：</span>
        <span>{{ item.attachRequiredFlag | dictFilter(attachRequiredFlagDictsOptions) }}</span>
      </van-row>
      <van-row>
        <span>验收说明必填：</span>
        <span>{{ item.receiveRemarkRequiredFlag | dictFilter(attachRequiredFlagDictsOptions) }}</span>
      </van-row>
      <van-row>
        <span>验收说明：</span>
        <span>{{ item.receiveRemark }}</span>
      </van-row>
      <van-row>
        <van-button type="info" size="normal" style="margin-bottom: 5px" @click="clickAttachmentModuleList(item)"
          >附件模版</van-button
        >
      </van-row>
      <van-row>
        <van-button type="info" size="normal" @click="clickAttachmentList(item)">附件</van-button>
      </van-row>
      <attachment-info
        v-if="attachmentModuleDialogVisible"
        :details-visible="attachmentModuleDialogVisible"
        :attach-list="attachmentModuleListItem"
        @close-details-dialog="attachmentModuleDialogVisible = false"
      />
      <attachment-info
        v-if="attachmentDialogVisible"
        :details-visible="attachmentDialogVisible"
        :attach-list="attachmentListItem"
        @close-details-dialog="attachmentDialogVisible = false"
      />
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'AcceptanceAttachmentDetails',
  components: {
    'attachment-info': () => import('./AttachmentInfo')
  },
  data() {
    return {
      attachmentModuleDialogVisible: false,
      attachmentModuleListItem: [],
      attachmentDialogVisible: false,
      attachmentListItem: []
    }
  },
  props: {
    detailsList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    attachRequiredFlagDictsOptions() {
      return this.$store.getters.dicts.is_active_dict
    }
  },
  methods: {
    clickAttachmentModuleList(item) {
      this.attachmentModuleListItem = item.attachmentTemplateFiles
      this.attachmentModuleDialogVisible = true
    },
    clickAttachmentList(item) {
      this.attachmentListItem = item.attachmentFiles
      this.attachmentDialogVisible = true
    }
  }
}
</script>
